"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const ui_1 = require("@completeanatomy/ui");
const react_router_dom_1 = require("react-router-dom");
const styled_components_1 = __importDefault(require("styled-components"));
const EmptyUserOwnGroupList_1 = __importDefault(require("../../atoms/EmptyUserOwnGroupList"));
const index_1 = require("../../molecules/index");
const index_2 = require("../index");
function GroupList({ title, groups, selected, onSelect, showCreateGroupButton = false, isMobile, isMyGroups, isCtaCardVisible, setCtaCardVisible, }) {
    const [searchParams] = (0, react_router_dom_1.useSearchParams)();
    const shouldOpenCreateGroupPopup = searchParams.get('create-group') === 'true' && isMyGroups;
    const [isCreationDialog, setIsCreationDialog] = (0, react_1.useState)(shouldOpenCreateGroupPopup);
    const onAdd = () => {
        if (isCtaCardVisible)
            return;
        setIsCreationDialog(true);
    };
    const onGetStartedButtonClick = () => {
        setIsCreationDialog(true);
        if (setCtaCardVisible) {
            setCtaCardVisible(false);
        }
    };
    const onCloseButtonClick = () => {
        if (setCtaCardVisible) {
            setCtaCardVisible(false);
        }
    };
    const onCloseDialog = () => {
        setIsCreationDialog(false);
    };
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)(GroupsContainer, { "data-e2e": 'GroupList_GroupsContainer', children: [(0, jsx_runtime_1.jsxs)(GroupsHeader, { "$isMobile": isMobile, "data-e2e": 'GroupList_GroupsHeader', children: [!isMobile && title, showCreateGroupButton && ((0, jsx_runtime_1.jsx)(AddButton, { "$isCtaCardVisible": isCtaCardVisible, onClick: onAdd, "data-e2e": 'GroupList_AddButton', children: (0, jsx_runtime_1.jsx)(AddButtonIcon, { name: ui_1.Icons.Cross, "data-e2e": 'GroupList_AddButtonIcon' }) }))] }), groups.length > 0 && ((0, jsx_runtime_1.jsx)(GroupsScroll, { "data-e2e": 'GroupList_GroupsScroll', children: groups.map(group => ((0, jsx_runtime_1.jsx)(index_1.GroupListItem, { group: group, selected: selected === group.identifier, onSelect: () => onSelect(group), isMobile: isMobile, "data-e2e": 'GroupList_GroupListItem' }, group.identifier))) })), isCtaCardVisible && ((0, jsx_runtime_1.jsx)(index_2.EmptyListCTACard, { onCloseButtonClick: onCloseButtonClick, onGetStartedClick: onGetStartedButtonClick, "data-e2e": 'GroupList_EmptyListCTACard' })), isMyGroups && !groups.length && !isCtaCardVisible && ((0, jsx_runtime_1.jsx)(StyledEmptyUserOwnGroupList, { "data-e2e": 'GroupList_StyledEmptyUserOwnGroupList' }))] }), (0, jsx_runtime_1.jsx)(ui_1.Popup, { isOpen: isCreationDialog, onClose: onCloseDialog, showCross: true, "data-e2e": 'GroupList_Popup', children: (0, jsx_runtime_1.jsx)(index_2.CreateGroup, { "data-e2e": 'GroupList_CreateGroup' }) })] }));
}
exports.default = GroupList;
const GroupsContainer = styled_components_1.default.div `
  flex-basis: 50%;
  flex-direction: column;
  flex-grow: 1;
  flex-shrink: 1;

  width: 100%;

  padding-bottom: env(safe-area-inset-bottom);
  padding-bottom: constant(safe-area-inset-bottom);
  margin: 0 0 20px 10px;

  display: flex;
  position: relative;
  align-items: center;
  justify-content: flex-start;

  overflow: hidden;
`;
const GroupsHeader = styled_components_1.default.div `
  position: relative;

  flex-shrink: 0;

  width: 100%;

  padding: ${({ $isMobile }) => $isMobile ? '0 0 5px 15px' : '20px 0 10px 15px'};

  color: ${props => props.theme.text};

  font-size: 12px;

  border-bottom: 1px solid ${props => props.theme.thinLine};
`;
const GroupsScroll = (0, styled_components_1.default)(ui_1.ScrollView) `
  flex-direction: column;

  box-sizing: border-box;

  width: 100%;

  padding: 20px 0 20px 40px;
`;
const AddButton = (0, styled_components_1.default)(ui_1.PrimaryButton) `
  position: absolute;
  right: 40px;
  bottom: -20px;

  width: 40px;
  height: 40px;

  padding: 0;

  border-radius: 50%;

  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  z-index: 1;

  cursor: ${({ $isCtaCardVisible }) => $isCtaCardVisible && 'auto'};
  opacity: ${({ $isCtaCardVisible }) => $isCtaCardVisible && '0.5'};
`;
const AddButtonIcon = (0, styled_components_1.default)(ui_1.Icon) `
  width: 12px;
  height: 12px;

  transform: rotate(45deg);
`;
const StyledEmptyUserOwnGroupList = (0, styled_components_1.default)(EmptyUserOwnGroupList_1.default) `
  margin-top: 50px;
`;
